import { formatWithLocale } from 'shared/lib/datepicker/helpers/dateHelper';
import { useCalendarDatepicker } from 'shared/lib/selectCalendar';
import { TDay } from 'shared/types';
import { CalendarDatePicker } from 'shared/ui/datepicker/calendarDatePicker';

export const SelectMenu = () => {
	const {
		setDateString,
		setSelectedDate,
		setDate,
		selectedDate,
		isOpenCalendar,
		toggleCalendarMenu,
	} = useCalendarDatepicker();

	const handleDateChange = (date: TDay) => {
		if (date) {
			const dateString = formatWithLocale(date, 'dd MMMM (EEE) yyyy');
			setDateString(dateString);
			setSelectedDate(date);
			setDate?.(date);
			toggleCalendarMenu();
		}
	};

	const handleMonthChange = (date: TDay) => {
		if (date) {
			const dateString = formatWithLocale(date, 'dd MMMM (EEE) yyyy');
			setDateString(dateString);
			setSelectedDate(date);
			setDate?.(date);
		}
	};

	return (
		<>
			<CalendarDatePicker
				selected={selectedDate}
				isOpenCalendar={isOpenCalendar}
				onSelect={handleDateChange}
				onMonthChange={handleMonthChange}
			/>
		</>
	);
};
